import { isBefore, isToday } from 'date-fns';

const isPastDay = (day: Date | string) => isBefore(day, new Date()) && !isToday(day);

export { isPastDay };
